import * as React from 'react'

const SvgTable = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={166}
    height={120}
    viewBox="0 0 166 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Table_svg__a)">
      <path
        d="m46.163 22.693-7.522 97.302h-5.465l7.517-97.302h5.47Z"
        fill="#9865FC"
      />
      <path
        d="m40.708 22.693-7.517 97.302h-5.47l7.522-97.302h5.465Z"
        fill="#7130C9"
      />
      <path
        d="m86.134 58.813 4.083 61.182h-5.47L80.67 58.813h5.465Z"
        fill="#9865FC"
      />
      <path
        d="m80.69 58.813 4.083 61.182h-5.465l-4.083-61.182h5.465Z"
        fill="#7130C9"
      />
      <path
        d="m60.96 58.813 4.077 61.182h-5.464l-4.084-61.182h5.47Z"
        fill="#9865FC"
      />
      <path
        d="m55.515 58.813 4.078 61.182h-5.465l-4.083-61.182h5.47Z"
        fill="#7130C9"
      />
      <path
        d="M16.24 4.828 6.192 119.995H.727L10.775 4.828h5.465Z"
        fill="#440A78"
      />
      <path
        d="M21.715 4.828 11.662 119.995H6.197L16.245 4.828h5.47Z"
        fill="#9865FC"
      />
      <path d="M55.443 1.46H5.057v21.645h50.386V1.46Z" fill="#E1CEFF" />
      <path d="M5.058 1.46H0v21.645h5.058V1.46Z" fill="#9865FC" />
      <path
        d="M92.1 67.17H50.802l-.531-8.357h41.27l.557 8.358Z"
        fill="#E1CEFF"
      />
      <path
        d="M50.788 67.17H10.8l.732-8.357h38.724l.53 8.358Z"
        fill="#440A78"
      />
      <path d="M166 38.225H71.957v5.469H166v-5.469Z" fill="#E1CEFF" />
      <path d="M81.804 38.225h-9.847v5.469h9.847v-5.469Z" fill="#440A78" />
      <path d="M118.981 43.693v76.302h5.465V43.693h-5.465Z" fill="#9865FC" />
      <path d="M113.511 43.699V120h5.465V43.699h-5.465Z" fill="#440A78" />
      <path d="M118.806 114.526h-15.292v5.469h15.292v-5.469Z" fill="#440A78" />
      <path
        d="M134.438 114.526h-21.19v5.469h21.19v-5.469ZM108.541 7.16h20.896l-2.625 31.065H111.16L108.541 7.16Z"
        fill="#E1CEFF"
      />
      <path
        d="m128.612 16.88-1.8 21.345H111.16l-1.799-21.346h19.251Z"
        fill="#9865FC"
      />
      <path
        d="M129.437 0a7.155 7.155 0 0 0-7.156 7.16h7.156l-.603 7.13c.201.015.397.03.603.03a7.155 7.155 0 0 0 7.156-7.16A7.155 7.155 0 0 0 129.437 0Z"
        fill="#FFC103"
      />
    </g>
    <defs>
      <clipPath id="Table_svg__a">
        <path fill="#fff" d="M0 0h166v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgTable
